import {
    createMuiTheme,
    CssBaseline,
    MuiThemeProvider,
    responsiveFontSizes,
} from '@material-ui/core';
import React from 'react';
import Router from './components/Router';
import UserContextProvider from './contexts/UserContext';
require('dotenv').config()

const theme = createMuiTheme({
    typography: {
        fontFamily:"Cabin"
    },
    palette: {
        type: 'light',
        primary:{
            main: '#04006e'
        },
        secondary:{
            main: '#565656'
        }
    },
});

const responsiveTheme = responsiveFontSizes(theme);

function App() {
    return (
        <MuiThemeProvider theme={responsiveTheme}> <CssBaseline/>  <UserContextProvider> <Router/> </UserContextProvider>
        </MuiThemeProvider>
    );
}

export default App;